export const getStaticUrl = originalUrl => {
  // Check for null or undefined input
  if (!originalUrl) {
    return null;
  }

  const urlParts = originalUrl.split('static/');

  if (urlParts.length !== 2) {
    // Handle incorrect URL format
    return null;
  }

  // Extract domain and path
  const domain = urlParts[0];
  const path = urlParts[1];

  // Encode path component
  const encodedPath = encodeURIComponent(path);

  // Handle concatenation properly
  // Ensure there's a forward slash between domain and path
  return domain.endsWith('/')
    ? domain + 'static/' + encodedPath
    : domain + '/static/' + encodedPath;
};
